import React from 'react'
import _ from 'common-tools/LodashHelper'
import PropTypes from 'prop-types'

export class SectionComponent extends React.Component {
  static propTypes = {
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)])
  }

  getChild (partIndex, partProps = {}, isRequired = true) {
    const { children } = this.props

    if (_.isArray(children) === false && partIndex > 0) {
      if (isRequired === true) {
        throw new Error('Invalid part index!  children is not an array so part index can only be 0')
      } else {
        return null
      }
    }

    if (_.isArray(children) === false && partIndex === 0) {
      return React.cloneElement(children, partProps)
    }

    if ((partIndex + 1) > children.length) {
      if (isRequired === false) {
        return null
      }
      throw new Error(`Invalid part index!  children only contains ${children.length} but you asked for position ${partIndex}`)
    }

    return React.cloneElement(children[partIndex], partProps)
  }

  getChildrenFromIndex (fromIndex, partProps = {}) {
    const { children } = this.props

    if (_.isArray(children) === false) {
      return null
    }

    if ((fromIndex + 1) > children.length) {
      return null
    }

    return _.map(children.slice(fromIndex), (child, i) => { return React.cloneElement(child, _.merge({ key: i }, partProps)) })
  }
}

export default SectionComponent
